import Footer from '../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Box, Container } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../Components/DrawerAppBar';
import Menus from '../Components/Menus';
import TitrePage from '../Components/TitrePage';
import EllipseGauche from "../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../Fichiers/Ellipse 201.svg"
import illution_4 from "../Fichiers/illution_4.svg";
import Conf from "../Fichiers/12291123_Wavy_Tech-24_Single-01.svg";

interface Props { }

function TermesEtConditions(props: Props) {
        const { t } = useTranslation();
        

    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={t("Label.titre.titre25")} lien={t("Label.titre.titre25")} />
            <br /><br /><br /><br /><br /><br /><br /><br /><br />

            <Box display={"flex"}>
                <Box  display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseGauche} alt="" />
                </Box>

                <Container style={{ backgroundColor: "rgba(255, 255, 255, .9)", borderRadius: "10px", boxShadow: "0px 0px 10px rgba(0, 0, 0, .3)", borderTop: "5px #0D6638 solid" }} maxWidth='lg'>
                    <center><img style={{position: "fixed", left: "3%", zIndex: "-1", opacity: "100%"}} width={300} src={Conf} alt="" /></center>
                    <br />
                    <label className='textgray' style={{ fontSize: 'large', fontWeight: "bold", textAlign: "right" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie1")}</label><br /><br />
                    <label className='textgray' style={{ textAlign: "right" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie2")}</label><br /><br />
                    <label className='textgray' style={{ textAlign: "right" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie3")}</label>

                    <br /><br />
                    <hr />

                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie4").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie5")}</label>
                        </motion.div>


                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie6").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie7")}</label><br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie8")}</label><br /><br />
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie9").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie10")}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie11")}</label>
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie12").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie13")}</label>
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie14").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie15")}</label><br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie16")}</label>
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie17").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie18")}</label><br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie19")}</label>
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie20").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie21")}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie22")}</label>
                        </motion.div>

                    </Box>
                    <br />
                    <Box textAlign={"justify"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <label style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie23").toUpperCase()}</label>
                            <br /><br />
                            <label htmlFor="">{t("TERMES_ET_CONDITIONS.texte.partie24")}</label>
                        </motion.div>

                    </Box>
                    <img width={"50%"} src={illution_4} alt="" />
                    <br /><br />
                </Container>
                <Box display={{ xs: 'none', sm: 'contents' }}>
                    <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseDroite} alt="" />
                </Box>
            </Box>

            <br /><br /><br />



            <Footer />
        </div>
    )
}
export default TermesEtConditions